
import axios from 'axios';

class modelListService {

    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL
        }
    }

    getCustomerList(searchKey) {
        return axios.get(this.state.apiUrl + "home/searchCustomers?name=" + searchKey, { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    getCustomerModelList(customerId) {
        return axios.get(this.state.apiUrl + "home/listModels?customerId=" + customerId, { silent: false })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    getMasterModel() {
        return axios.get(this.state.apiUrl + "model/masterModelReference", { silent: true })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }
}
export default modelListService;